module.exports = __webpack_public_path__ + "static/img/gy.79fcf270.svg";